import { useAtomValue, useSetAtom } from 'jotai'
import { sidebarOpenAtom } from '../state/store'
import { useMobile } from '../hooks/useMobile'

export function ChatbotLayout({ children }: { children: React.ReactNode }) {
  const sidebarOpen = useAtomValue(sidebarOpenAtom)
  const setSidebarOpen = useSetAtom(sidebarOpenAtom)
  const isMobile = useMobile()

  return (
    <div className="relative flex h-full w-full overflow-hidden bg-background text-foreground font-base">
      {/* Mobile overlay backdrop */}
      {isMobile && sidebarOpen && (
        <div
          className="absolute inset-0 z-30 bg-black/60 transition-opacity"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      {children}
    </div>
  )
}
